export const paddingTopFix = 32

export const transitionString = 'transform 0.2s ease-out'
